<template>
  <div>
    <div v-if="!contactData" class="examples">
      <a-spin />
    </div>
    <div v-else class="footer-box primary-bg">
      <img v-if="commonData.web_map.value" :src="commonData.web_map.value" width="100%" />
      <div class="footer-triangle">
        <div class="footer-textk">
          <div class="footer-icon" v-for="(item, i) of contactData" :key="i">
            <img :src="item.contact_icon" class="footer-icon-img">
            <p class="footer-text" v-for="(data, ind) in item.contact_message.split(',')" :key="ind"> {{data}} </p>
          </div>
        </div>
      </div>
      <div class="footer-bg">
        <div class="footer-bottombtn">
          <ul>
            <li v-for="(item, ind) in navList" :key="ind"
              @click="gotoNav(item.value)">{{item.label_zh}}</li>
            <li> <span @click="visibleFlsm=true">法律声明</span> </li>
            <li @click="switchEnglish"><span>ENGLISH</span></li>
          </ul>
        </div>
        <div class="footer-bottom">
          <div class="footer-solid">
          </div>
          <div class="footer-leftimg">
            <img @click="gotoNav('/')" width="180px" height="50px" alt="logo"
              v-if="commonData.web_logo && commonData.web_logo.value"
              :src="commonData.web_logo.value">
          </div>
          <div class="footer-records">
            <div class="footer-righttext dis-ib" v-if="commonData.web_net.value">
              <a class="white" target="_black" :href="commonData.web_net.value.split(',')[1]" v-if="commonData.web_net">
                <span>
                  <img class="wi-18 ht-18 pr tp--2" src="https://suisuixiang.oss-cn-beijing.aliyuncs.com/2934%2A%2A%2A%2Acom/2022-08-12/13b1a19199dbf90c3965c1e3b0e0824.png" alt="">
                  {{commonData.web_net.value.split(',')[0]}}</span>
              </a>
            </div>
            <div class="footer-righttext dis-ib" v-if="commonData.web_icp.value">
              <a class="white" target="_black" :href="commonData.web_icp.value.split(',')[1]" v-if="commonData.web_icp">
                <span>{{commonData.web_icp.value.split(',')[0]}}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-flsm" v-if="visibleFlsm">
        <div class="flsm-dialog">
          <div class="title-bar">
            <span>法律声明</span>
            <a-icon type="close" @click="visibleFlsm = false" />
          </div>
          <img class="backimg" src="../../static/img/footer-flsm.svg" width="100%" />
          <div class="content wordbreak">{{commonData.web_terms.value}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: mapGetters([
    'commonData'
  ]),
  data () {
    return {
      visibleFlsm: false,
      navList: [],
      contactData: []
    }
  },
  watch: {
    'commonData.web_pages' (obj) {
      this.navList = JSON.parse(obj.value)
    },
    'commonData.web_contact' (obj) {
      this.contactData = JSON.parse(obj.value)
    }
  },
  mounted () {
    if (this.commonData.web_pages.value) {
      this.navList = JSON.parse(this.commonData.web_pages.value)
      this.contactData = JSON.parse(this.commonData.web_contact.value)
    }
  },
  methods: {
    gotoNav (router) {
      window.scroll(0, 0)
      this.$router.push(router)
    },
    switchEnglish () {
      window.location.href = 'https://www.rongyinglaw.com/en/#/home'
    }
  }
}
</script>

<style lang="less">
@import url('../utils/color.less');
@media screen and (max-width: 751px) and (min-width: 300px) {
 .footer-box {
    position: relative;
    .footer-triangle {
      width: 0;
      height: 0;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid white;
      position: absolute;
      top: 50px;
      left: 174px;
      right: 0;
      bottom: 0;
      .footer-textk {
        width: 360px;
        height: 180px;
        position: absolute;
        top: 15px;
        left: -186px;
        right: 0;
        bottom: 0;
        background-color: white;
        .footer-icon {
          margin-left: 20px;
          color: #02397c;
          margin-top: 15px;
          .footer-icon-img {
            width: 20px;
            height: 20px;
          }
          .footer-text {
            padding-right: 20px;
            margin-top: -20px;
            margin-left: 40px;
            color: #02397c;
            font-size: 16px;
          }
        }
      }
    }
    .footer-bg {
      width: 100%;
      position: relative;
      padding-top: 140px;
    }
    .footer-bottombtn {
      ul {
        width: 100%;
        text-align: left;
        overflow: hidden;
      }
      li {
        display: inline-block;
        width: 50%;
        line-height: 36px;
        font-size: 14px;
        color: white;
        padding-left: 16px;
        float: left;
      }
      li:hover {
        color: #DBA77F;
      }
    }
    .footer-bottom {
      padding: 0 16px 20px;
      .footer-solid {
        width: 100%;
        border-top: 1px solid #336097;
      }
      .footer-leftimg {
        display: none;
      }
      .footer-righttext {
        color: white;
        font-size: 14px;
        margin-top: 20px;
      }
    }
    .footer-flsm {
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.7);
      position: fixed;
      z-index: 999;
      left: 0;
      top: 0;
      .flsm-dialog {
        width: 360px;
        height: 500px;
        border-radius: 6px;
        background-color: #FFF;
        overflow: hidden;
        padding: 50px 10px 30px 10px;
        margin: auto;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .title-bar {
          color: black;
          width: 100%;
          height: 60px;
          padding: 10px 20px;
          position: relative;
          z-index: 2;
          font-size: 26px;
          display: -webkit-flex;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: absolute;
          left: 0;
          top: 0;
          i {
            cursor: pointer;
            font-size: 16px;
          }
        }
        .backimg {
          display: none;
        }
        .content {
          padding: 10px;
          overflow: auto;
          height: 100%;
          &::-webkit-scrollbar {
            width: 4px;
            background-color: rgba(0,0,0,0.1);
            border-radius: 3px;
          }
          &::-webkit-scrollbar-thumb {
            background-color: rgba(0,0,0,0.2);
            border-radius: 3px;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 751px) {
  @width: 80%;
  .footer-box {
    position: relative;
    .footer-triangle {
      width: 0;
      height: 0;
      border-left: 80px solid transparent;
      border-right: 80px solid transparent;
      border-bottom: 100px solid white;
      position: absolute;
      top: -40%;
      left: 4%;
      right: 0;
      bottom: 0;
      margin: auto;
      .footer-textk {
        width: 510px;
        height: 220px;
        position: absolute;
        top: 30px;
        left: -255px;
        right: 0;
        bottom: 0;
        background-color: white;
        .footer-icon {
          margin-top: 10px;
          margin-left: 20px;
          color: #02397c;
          .footer-icon-img {
            width: 20px;
            height: 40px;
          }
          .footer-text {
            padding-right: 20px;
            margin-top: -30px;
            margin-left: 40px;
            color: #02397c;
            font-size: 16px;
            padding-bottom: 10px
          }
        }
      }
    }
    .footer-bg {
      width: @width;
      height: 250px;
      padding-top: 90px;
      margin: auto;
      position: relative;
      max-width: 1400px;
    }
    .footer-bottombtn {
      ul {
        width: 100%;
        text-align: center;
      }
      li {
        display: inline-block;
        margin: 0 20px;
        font-size: 14px;
        color: white;
        cursor: pointer;
      }
      li:hover {
        color: #DBA77F;
      }
    }
    .footer-bottom {
      .footer-solid {
        width: 100%;
        border-top: 1px solid #336097;
      }
      .footer-leftimg {
        position: absolute;
        bottom: 40px;
        left: 0;
      }
      .footer-records {
        color: white;
        font-size: 14px;
        position: absolute;
        bottom: 50px;
        right: 0;
        span {
          margin-left: 20px;
        }
      }
      .footer-righttext {
        &:hover {
          a {
            color: @support;
          }
        }
      }
    }
    .footer-flsm {
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.7);
      position: fixed;
      z-index: 999;
      left: 0;
      top: 0;
      .flsm-dialog {
        width: 800px;
        height: 600px;
        border-radius: 6px;
        background-color: #FFF;
        overflow: hidden;
        padding: 240px 30px 30px;
        margin: auto;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .title-bar {
          width: 100%;
          height: 90px;
          padding: 0 40px;
          position: relative;
          z-index: 2;
          color: #FFF;
          font-size: 30px;
          display: -webkit-flex;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: absolute;
          left: 0;
          top: 0;
          i {
            cursor: pointer;
            font-size: 16px;
          }
        }
        .backimg {
          width: 100%;
          height: 228px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .content {
          padding: 10px;
          height: 100%;
          overflow: auto;
          &::-webkit-scrollbar {
            width: 4px;
            background-color: rgba(0,0,0,0.1);
            border-radius: 3px;
          }
          &::-webkit-scrollbar-thumb {
            background-color: rgba(0,0,0,0.6);
            border-radius: 3px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/footer.vue